import React from 'react'
import EditComponent from './AreaEdit';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';

export default function Area(props: any) {
    /** api服务id */
    const apiId = 'area';

    //表头
    const columnsHead = [
        {
            title: '名称',
            dataIndex: 'areaName',
        },
        {
            title: '英文',
            dataIndex: 'areaEnName',
        },
        {
            title: '默认',
            dataIndex: 'isDefault',
            render:(text:any)=>(text?"是":"否")
        },
        
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '区域',
        apiId,
        columns,
        showStates: true,
        pagination: true,
        EditComponent,
        // extendIdName: "",

        // showDefault: true
    };

    return (
        <WebUniversal props={extendProps} />
    )
}

